'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$6() {
  this.bkN = null;
  this.bkL = null;
  this.bkM = false;
  this.bkJ = null;
  this.bkK = false;
  this.bkO = false;
  this.bkP = false;
  this.bkN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$6 as $c_Lpresto_PrestoRouter$$anon$6 };
$p = $c_Lpresto_PrestoRouter$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$6;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$6() {
}
export { $h_Lpresto_PrestoRouter$$anon$6 as $h_Lpresto_PrestoRouter$$anon$6 };
$h_Lpresto_PrestoRouter$$anon$6.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bkN;
});
$p.t = (function() {
  if ((!this.bkM)) {
    this.bkL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bkM = true;
  }
  return this.bkL;
});
$p.ae = (function() {
  if ((!this.bkK)) {
    this.bkJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bkK = true;
  }
  return this.bkJ;
});
$p.w = (function() {
  if ((!this.bkP)) {
    this.bkO = false;
    this.bkP = true;
  }
  return this.bkO;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$6, "presto.PrestoRouter$$anon$6", ({
  Or: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$6 as $d_Lpresto_PrestoRouter$$anon$6 };
//# sourceMappingURL=presto.-Presto-Router$$anon$6.js.map
